import type { Dispatch, ReactNode, SetStateAction } from 'react'
import { useState } from 'react'
import type { CompositionContextValue } from '@joyful/utils'
import { createNonNullableContext } from '@joyful/utils'

import type { DropdownMenuProps } from '../../core'
import { DropdownMenu } from '../../core'

interface UserDropdownMenuState {
  isUserDropdownMenuOpen: boolean
}

interface UserDropdownMenuActions {
  setUserDropdownMenuOpen: Dispatch<SetStateAction<boolean>>
}

export type UserDropdownMenuContextValue = CompositionContextValue<
  UserDropdownMenuState,
  UserDropdownMenuActions
>

const UserDropdownMenuContext =
  createNonNullableContext<UserDropdownMenuContextValue>(
    'UserDropdownMenuContext',
  )

export const UserDropdownMenuProvider = UserDropdownMenuContext.Context
export const useUserDropdownMenu = UserDropdownMenuContext.useRequiredContext

export function UserDropdownMenuStateProvider({
  children,
}: {
  readonly children: ReactNode
}) {
  const [isUserDropdownMenuOpen, setUserDropdownMenuOpen] = useState(false)

  return (
    <UserDropdownMenuProvider
      value={{
        actions: {
          setUserDropdownMenuOpen,
        },
        state: {
          isUserDropdownMenuOpen,
        },
      }}
    >
      {children}
    </UserDropdownMenuProvider>
  )
}

export function UserDropdownMenu(
  props: Omit<DropdownMenuProps, 'open' | 'onOpenChange'>,
) {
  const userDropdownMenu = useUserDropdownMenu()
  return (
    <DropdownMenu
      open={userDropdownMenu.state.isUserDropdownMenuOpen}
      onOpenChange={userDropdownMenu.actions.setUserDropdownMenuOpen}
      {...props}
    />
  )
}
